import {
  initialState,
  Actions,
  State,
  GET_ONE_SESSION,
  GET_ONE_SESSION_SUCCESS,
  GET_ONE_SESSION_ERROR,
  RESET_GET_ONE_SESSION,
} from "../../types/session/one";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_SESSION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ONE_SESSION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ONE_SESSION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_ONE_SESSION:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducers;
